<script setup lang="ts">
import { useCommonStore } from "~/stores/common/store";
import moment from "moment";

const { $CC } = useNuxtApp();
const commonStore = useCommonStore();

interface SubNavItem {
  title: string;
  link?: string;
  target?: string;
  command?: () => void;
}

// Interface for the main footer links
interface FooterLink {
  title: string;
  link: string;
  subNav?: SubNavItem[];
}

const socialIcons = [
  {
    icon: ["fab", "facebook"],
    link: "https://www.facebook.com/pokergo",
  },
  {
    icon: ["fab", "x-twitter"],
    link: "https://twitter.com/pokergo",
  },
  {
    icon: ["fab", "instagram"],
    link: "https://www.instagram.com/pokergo/",
  },
  {
    icon: ["fab", "youtube"],
    link: "https://www.youtube.com/channel/UCOPw3R-TUUNqgN2bQyidW2w",
  },
  {
    icon: ["fab", "discord"],
    link: "https://discord.gg/pokergo",
  },
];

const footerLinks: FooterLink[] = [
  {
    title: "About",
    link: "/about",
    subNav: [
      {
        title: "About PokerGO",
        link: "/about",
      },
      {
        target: "_blank",
        title: "Press Releases",
        link: "https://www.pokergonews.com/press-releases/",
      },
    ],
  },
  {
    title: "Support",
    link: "/about",
    subNav: [
      {
        title: "FAQ",
        link: "/faq",
      },
      {
        title: "Contact",
        link: "/faq#contact",
      },
      {
        title: "Cookie Preferences",
        command: () => {
          $CC.showPreferences();
          ("/faq#contact");
        },
      },
    ],
  },
  {
    title: "Legal",
    link: "/about",
    subNav: [
      {
        target: "_blank",
        title: "Privacy Policy",
        link: "/privacy-policy",
      },
      {
        target: "_blank",
        title: "Terms of Use",
        link: "/terms-of-use",
      },
    ],
  },
];
</script>

<template>
  <div class="border-t border-white/20 lg:mx-8">
    <div
      class="mx-auto flex max-w-screen-lg flex-col items-center justify-between py-8 md:flex-row md:items-start lg:py-10"
    >
      <div class="mb-8 lg:mb-0">
        <div class="mb-4 w-72 text-center lg:mb-10 lg:w-fit lg:text-left">
          <NuxtLink to="/">
            <img src="~/assets/images/logos/get-in-the-game.png" alt="Logo" />
          </NuxtLink>
        </div>

        <div class="mb-4 flex justify-center gap-8 lg:mb-10 lg:justify-start">
          <NuxtLink
            v-for="(icon, idx) in socialIcons"
            :key="`social_icon_${idx}`"
            :to="icon.link"
            target="_blank"
          >
            <font-awesome-icon :icon="icon.icon" class="text-2xl" />
          </NuxtLink>
        </div>
        <div class="text-center lg:text-left">
          © {{ moment().format("YYYY") }} PokerGO LLC. All Rights Reserved.
        </div>
      </div>
      <div>
        <div
          class="flex gap-10 py-4 text-center text-xs md:mx-0 lg:gap-20 lg:px-5 lg:text-left lg:text-base"
        >
          <div v-for="(category, index) in footerLinks" :key="index">
            <div class="mb-4 uppercase">{{ category.title }}</div>
            <div class="flex flex-col gap-2">
              <div
                v-for="(subLink, indexSubLink) in category.subNav"
                :key="indexSubLink"
              >
                <NuxtLink
                  class="cursor-pointer"
                  :to="subLink.link"
                  :target="subLink.target ?? '_self'"
                  @click="subLink.command"
                >
                  {{ subLink.title }}
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
